import { atom } from 'jotai';

const isEducationModalOpen = atom(false);

export default isEducationModalOpen;
